module.exports = __webpack_public_path__ + "img/financing-icon.44f2e11a.svg";